import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const Card = styled.div`
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 12px 16px;
  background: #fff;

  .cardHeader {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 8px;
  }

  .cardTitle {
    font-size: 16px;
    font-weight: bold;
    color: #684e94;
    word-break: break-word;
  }

  .cardSubtitle {
    color: #595959;
    font-size: 13px;
  }

  .cardInfo {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 16px;
    margin-bottom: 8px;
    font-size: 13px;
    color: #595959;

    strong {
      color: #262626;
    }
  }

  .cardGrid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px 12px;
  }

  .cardField {
    min-width: 0;

    &.fullWidth {
      grid-column: 1 / -1;
    }

    > label {
      display: block;
      margin: 0 0 4px 0;
      color: #9074bf;
      font-size: 13px;
      font-weight: bold;
    }
  }

  .historyChips {
    margin-bottom: 8px;
  }

  .scaleButtons {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;

    .ant-btn {
      min-width: 52px;
      min-height: 44px;
    }
  }

  .ant-select,
  .ant-input-number {
    width: 100%;
  }
`;
